export default function FileIcon(props) {
  const { stroke, ...oRest } = props
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...oRest}
    >
      <path
        d="M9.58333 2.8105V5.01345C9.58333 5.31215 9.58333 5.46149 9.64146 5.57558C9.6926 5.67593 9.77419 5.75752 9.87454 5.80866C9.98862 5.86679 10.138 5.86679 10.4367 5.86679H12.6396M10.65 8.53341H6.38333M10.65 10.6667H6.38333M7.45 6.40008H6.38333M9.58333 2.66675H6.81C5.91392 2.66675 5.46587 2.66675 5.12362 2.84114C4.82256 2.99453 4.57779 3.2393 4.42439 3.54036C4.25 3.88262 4.25 4.33066 4.25 5.22675V10.7734C4.25 11.6695 4.25 12.1175 4.42439 12.4598C4.57779 12.7609 4.82256 13.0056 5.12362 13.159C5.46587 13.3334 5.91392 13.3334 6.81 13.3334H10.2233C11.1194 13.3334 11.5675 13.3334 11.9097 13.159C12.2108 13.0056 12.4555 12.7609 12.6089 12.4598C12.7833 12.1175 12.7833 11.6695 12.7833 10.7734V5.86675L9.58333 2.66675Z"
        stroke={stroke || "#6CB6E3"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
